import { KeyValue } from '@/main/models/common';
import { SupervisorFilterRequest } from '@/main/models/request/supervisorRequest';
import { SupervisorResponse } from '@/main/models/response/supervisorResponse';

export enum SupervisorTypes {
  GET_SUPERVISOR = '@supervisor/GET_SUPERVISOR',
  GET_SUPERVISOR_DOMAIN = '@supervisor/GET_SUPERVISOR_DOMAIN',
  SAVE_SUPERVISOR = '@supervisor/SAVE_SUPERVISOR',
  SAVE_SUPERVISOR_DOMAIN = '@supervisor/SAVE_SUPERVISOR_DOMAIN',
  RESET_REDUCER_SUPERVISOR = '@supervisor/RESET_REDUCER_SUPERVISOR',
}

export interface SupervisorState {
  readonly supervisors: {
    data: SupervisorResponse | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly domain: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly isolated: {
    [key: string]: {
      data: SupervisorResponse | null;
      errorMessages: string[] | null;
      isError: boolean;
      isLoading: boolean;
    };
  };
}

export interface GetSupervisors {
  type: typeof SupervisorTypes.GET_SUPERVISOR;
  payload: {
    request: SupervisorFilterRequest;
    keyReducer: string;
  };
}

export interface GetSupervisorsDomain {
  type: typeof SupervisorTypes.GET_SUPERVISOR_DOMAIN;
  payload: {
    request: SupervisorFilterRequest;
    keyReducer: string;
  };
}

export interface SaveSupervisors {
  type: typeof SupervisorTypes.SAVE_SUPERVISOR;
  payload: {
    data: SupervisorResponse | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}

export interface SaveSupervisorsDomain {
  type: typeof SupervisorTypes.SAVE_SUPERVISOR_DOMAIN;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerSupervisors {
  type: typeof SupervisorTypes.RESET_REDUCER_SUPERVISOR;
}

export type SupervisorActionTypes =
  | GetSupervisors
  | GetSupervisorsDomain
  | SaveSupervisors
  | SaveSupervisorsDomain
  | ResetReducerSupervisors;

